// Partner configurations for dynamic routing
export const PARTNER_CONFIGS = {
  // Partner-specific configurations
  'patrauma': {
    name: 'Patrauma Party',
    type: 'partner',
    landingPage: 'LandingA',
    couponCode: 'PATRAUMA1MONTH',
    couponDetails: {
      amount_off: 999,
      duration: 'once',
      description: '$9.99 off one time from Patrauma Party',
      restrictions: {
        minimum_amount: 0,
        minimum_amount_currency: 'usd'
      }
    },
    utmSource: 'patrauma',
    customContent: {
      headline: 'Patrauma Party partners with Audioread',
      subheadline: 'Get 1 month free for the Patrauma Party community',
      socialProof: 'Join 50,000+ Patrauma Party listeners'
    }
  },
  // Add more partners here
  'startupweekly': {
    name: 'Startup Weekly',
    type: 'partner',
    landingPage: 'LandingA',
    couponCode: 'STARTUPWEEKLY50',
    couponDetails: {
      percent_off: 50,
      duration: 'repeating',
      duration_in_months: 3,
      description: '50% off for 3 months from Startup Weekly'
    },
    utmSource: 'startupweekly',
    customContent: {
      headline: 'Startup Weekly partners with Audioread',
      subheadline: 'Get 50% off for 3 months for the startup community',
      socialProof: 'Join 25,000+ startup founders'
    }
  }
};

// Coupon-only configurations (no partner landing page)
export const COUPON_CONFIGS = {
  'LISTEN30': {
    type: 'coupon',
    couponCode: 'LISTEN30',
    couponDetails: {
      percent_off: 30,
      duration: 'repeating',
      duration_in_months: 12,
      description: '30% off your first month'
    },
    utmSource: 'listen30'
  },
  'FREETRIAL': {
    type: 'coupon',
    couponCode: 'FREETRIAL',
    couponDetails: {
      percent_off: 100,
      duration: 'repeating',
      duration_in_months: 1,
      description: '1 month free trial'
    },
    utmSource: 'freetrial'
  }
};

// Referral configurations
export const REFERRAL_CONFIGS = {
  default: {
    type: 'referral',
    couponCode: 'REFERRAL',
    couponDetails: {
      percent_off: 100,
      duration: 'repeating',
      duration_in_months: 1,
      description: '1 month free from referral'
    },
    utmSource: 'referral',
    extraCredits: 1 // months
  }
};

// Helper function to get config by route
export const getConfigByRoute = (route) => {
  // Check if it's a partner route
  if (PARTNER_CONFIGS[route]) {
    return PARTNER_CONFIGS[route];
  }
  
  // Check if it's a coupon route - now handles both formats
  if (route.startsWith('code/')) {
    const couponCode = route.replace('code/', '');
    return COUPON_CONFIGS[couponCode] || null;
  }
  
  // Check if it's a referral route (UUID format)
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  if (uuidRegex.test(route)) {
    return REFERRAL_CONFIGS.default;
  }
  
  // Check if it's a direct coupon code (for new routing)
  if (COUPON_CONFIGS[route]) {
    return COUPON_CONFIGS[route];
  }
  
  // If no config found, return null - this will prevent undefined routes from being processed
  return null;
};

// Helper function to get coupon code from route
export const getCouponCodeFromRoute = (route) => {
  const config = getConfigByRoute(route);
  return config?.couponCode || null;
};

// Helper function to check if route is a partner route
export const isPartnerRoute = (route) => {
  // Only return true if it's actually a defined partner, not any random string
  return !!PARTNER_CONFIGS[route];
};

// Helper function to check if route is a coupon route
export const isCouponRoute = (route) => {
  // Check if it starts with 'code/' (old format) or if it's a direct coupon code
  return route.startsWith('code/') || !!COUPON_CONFIGS[route];
};

// Helper function to check if route is a referral route
export const isReferralRoute = (route) => {
  // For referral routes, the route parameter is just the UUID
  // We need to check if it's a valid UUID format (36 characters with hyphens)
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(route);
};
